import { getElColorPrimary } from '@/utils/theme-color'

/** 监控进度条颜色：≥80% 红，50%～80% 黄，&lt;50% 蓝 */
export function getMonitorProgressColor(percentage: number): string {
  if (percentage >= 80) return '#E54545'
  if (percentage >= 50) return '#E6A23C'
  return getElColorPrimary()
}
